import CustomTable from "./CustomTable";
const ListViewContainer = ({
  breadcrumbs,
  tabSection,
  searchBar,
  tableData = {
    rows: [],
    columns: [],
    paginationState: [],
    isLoading: true,
    checkboxShowFalse: true,
  },
  showHeaderSection,
}) => {
  return (
    <>
      <div>
        <CustomTable
          rows={tableData.rows}
          columns={tableData.columns}
          paginationState={tableData.paginationState}
          loading={tableData.isLoading}
          showHeaderSection={showHeaderSection}
          checkboxShowFalse={tableData.checkboxShowFalse}
        />
      </div>
    </>
  );
};
export default ListViewContainer;

// import React from "react";
// import CustomTable from "./CustomTable";
// const ListViewContainer = ({
//   searchBar,
//   tableData = {
//     rows: [],
//     columns: [],
//     paginationState: [],
//     isLoading: true,
//     checkboxShowFalse: true,
//   },
//   showHeaderSection,
// }) => {
//   const [pagination, setPagination] = tableData.paginationState;

//   const handlePerPageChange = (e) => {
//     const newLimit = parseInt(e.target.value);
//     console.log("newLimit",newLimit)  
//   setPagination((prev) => ({
//       ...prev,
//       per_page: newLimit,
//       page: 1,
//     }));
//   };

//   return (
//     <div>
//       <div className="d-flex justify-content-end align-items-center mb-2">
//         <label htmlFor="perPageSelect" className="me-2 mb-0">
//           Records per page:
//         </label>
//         <select
//           id="perPageSelect"
//           className="form-select form-select-sm w-auto"
//           value={pagination.per_page}
//           onChange={handlePerPageChange}
//         >
//           <option value=""> Select</option>
//           {[100, 500,1000,1500].map((option) => (
//             <option key={option} value={option}>
//               {option}
//             </option>
//           ))}
//         </select>
//       </div>

//       <CustomTable
//         rows={tableData.rows}
//         columns={tableData.columns}
//         paginationState=""
//         loading={tableData.isLoading}
//         showHeaderSection={showHeaderSection}
//         checkboxShowFalse={tableData.checkboxShowFalse}
//       />
//     </div>
//   );
// };

// export default ListViewContainer;


